// Example:
//
//   formatString("{name} is {age} years old.", { name: "John", age: 32 })
//     => "John is 32 years old."
//
export default function formatString(pattern, values) {
  return pattern.replaceAll(/\{(\w+)\}/g, (_, key) => values[key])
}
